/**
 * Parse errors from cognito and supply useful messages to the user.
 * Assumes that the user has a valid session (e.g an authorized route).
 *
 * Expects a scoped logger to be passed along with the error.
 */
export default function errorToFriendlyMessage(error, log) {
  if (error.code === 'UserNotFoundException') {
    log.warning({
      message: 'User account not found while in authenticated context.',
      exception: error,
    });
    return 'Your user account has been deleted, probably by you. ' +
           'Contact support if you find this strange.';
  }

  if (error.code === 'NotAuthorizedException' && /disabled/.test(error.message)) {
    log.warning({
      message: 'User account disabled while in authenticated context.',
      exception: error,
    });
    return 'Your user account has been disabled, contact support to find out why.';
  }

  if (error.code === 'NotAuthorizedException' && /revoked/.test(error.message)) {
    log.information({
      message: 'User session revoked while in authenticated context.',
      exception: error,
    });
    return 'Your session has been invalidated, probably by you.';
  }

  if (error.code === 'WXNotAuthenticated') {
    log.information({
      message: 'Access attempt denied because the user was not authenticated',
      exception: error,
    });
    return 'Your request was denied because you are not logged in.';
  }

  log.error({
    message: 'Encountered unmatched error in authenticated context.',
    exception: error,
  });

  return error.message;
}



// WEBPACK FOOTER //
// ./src/auth/errors.js